import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './NotFound.scss';
import Layout from '../../components/Layout';

class NotFound extends React.Component {
  render() {
    return (
      <Layout>
        <div className={s.root}>
          <div className={s.container}>
            <h1>404</h1>
            <p>Sorry, the page you were trying to view does not exist.</p>
          </div>
        </div>
      </Layout>
    );
  }
}

export default withStyles(s)(NotFound);



// WEBPACK FOOTER //
// ./src/routes/notFound/NotFound.js